import React from "react";
import { getStatusColor } from "./statusUtils";
import { useNavigate } from "react-router-dom";

const ServiceRow = ({ index, service, onToggleStatus, onDelete }) => {
  const navigate = useNavigate();

  return (
    <tr className="border-b border-gray-100 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition">
      <td className="py-4 px-4 text-sm font-bold text-navy-700 dark:text-white">{index + 1}</td>

      <td className="py-4 px-4">
        <div className="flex items-center gap-3">
          {service.banner_img ? (
            <img
              src={service.banner_img}
              alt=""
              className="w-10 h-10 rounded-lg object-cover border border-gray-200 dark:border-white/10 flex-shrink-0"
            />
          ) : (
            <div className="w-10 h-10 rounded-lg bg-gray-200 dark:bg-white/10 flex-shrink-0 flex items-center justify-center text-gray-400 text-lg">
              —
            </div>
          )}
          <div>
            <div className="text-sm font-semibold text-navy-700 dark:text-white">{service.name}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">ID: {service.id}</div>
          </div>
        </div>
      </td>

      <td className="py-4 px-4 text-sm">
        <span className="font-bold text-blue-600 dark:text-blue-400">
          {service.products.length} product{service.products.length !== 1 ? "s" : ""}
        </span>
        {(service.addons || []).length > 0 && (
          <span className="ml-2 font-bold text-purple-600 dark:text-purple-400">
            · {service.addons.length} addon{service.addons.length !== 1 ? "s" : ""}
          </span>
        )}
      </td>

      <td className="py-4 px-4">
        <button
          onClick={() => onToggleStatus(service.id)}
          className={`inline-flex rounded-full px-4 py-2 text-xs font-semibold transition cursor-pointer ${getStatusColor(
            service.status
          )}`}
        >
          {service.status === "active" ? " Active" : " Inactive"}
        </button>
      </td>

      <td className="py-4 px-4">
        <div className="flex gap-2">
          {/* View navigates internally */}
          <button
            onClick={() => navigate(`/admin/services/${service.id}`)}
            className="text-xs px-3 py-2 bg-brand-500 hover:bg-brand-600 text-white rounded-md transition font-semibold"
            title="View Service & Products"
          >
            View
          </button>

          {/* Delete delegates up */}
          <button
            onClick={() => onDelete(service)}
            className="text-xs px-3 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md transition font-semibold"
            title="Delete this Service"
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ServiceRow;